<template>
  <b-modal
    :id="modalId"
    v-model="show"
    centered
    hide-header
    hide-footer
    body-class="p-0"
    lazy
    @cancel="onClose"
    @ok="onOk"
    @hide="onHide"
  >
    <div class="p-3 p-sm-2 p-md-5 v-flex" :class="{ modalHeight: viewOk }">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>{{ $t('users.addUsers') }}</h3>
        <b-button variant="transparent" class="p-0 text-muted btn-icon-prepend" @click="onClose">
          <svg-icon name="x" size="24" class="fill-icon"></svg-icon>
        </b-button>
      </div>
      <div v-if="!viewOk">
        <p class="text-muted subtitle">{{ $t('users.modal.description') }}</p>
        <b-form-group
          label-class="text-muted subtitle"
          :label="$t('users.modal.email')"
          label-for="email"
        >
          <b-form-textarea
            id="email"
            v-model.lazy="emailString"
            rows="1"
            max-rows="6"
            placeholder="ivanov@gmail.com, antonov@gmail.com, stepanov..."
            class="bg-white text-black px-2 scrollbar"
          ></b-form-textarea>
          <b-form-invalid-feedback :state="state">
            {{ $t('users.modal.emailValidation') }}
            <div v-for="(item, i) in validationFail" :key="i">
              <span>{{ i }}. {{ item ? item : $t('users.modal.emptyEmail') }}</span>
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label-class="text-muted subtitle"
          :label="$t('users.modal.org')"
          label-for="orgSelector"
        >
          <model-select
            id="orgSelector"
            v-model.lazy="objectId"
            :options="availableObjects"
          ></model-select>
        </b-form-group>
        <b-form-group>
          <div label-for="roleSelector" class="text-muted subtitle d-flex pb-2">
            {{ $t('users.modal.role') }}
            <div id="role">
              <svg-icon name="info" class="fill-icon ml-1 mb-0" size="24"></svg-icon>
            </div>
            <b-tooltip custom-class="info-tooltip tooltipShadow p-0" variant="third" target="role">
              <div class="text-left">
                <p>
                  <b>{{ $t('roles.OEE_USER') }}</b>
                  {{ $t('users.modal.user') }}
                </p>
                <p>
                  <b>{{ $t('roles.OEE_PM') }}</b>
                  {{ $t('users.modal.head') }}
                </p>
              </div>
            </b-tooltip>
          </div>
          <model-select id="roleSelector" v-model="role" :options="groupOptions"></model-select>
        </b-form-group>
        <div
          class="d-none d-sm-none d-md-flex flex-row-reverse justify-content-between align-items-center mt-4"
        >
          <b-button :disabled="!buttonControl" size="lg" variant="primary" @click="onOk">
            {{ $t('users.modal.save') }}
          </b-button>
          <b-button size="lg" variant="transparent" @click="onClose">
            {{ $t('button.cancel.label') }}
          </b-button>
        </div>
        <div class="d-block d-sm-block d-md-none mt-4">
          <b-button :disabled="!buttonControl" block size="lg" variant="primary" @click="onOk">
            {{ $t('users.modal.save') }}
          </b-button>
          <b-button block size="lg" variant="transparent" @click="onClose">
            {{ $t('button.cancel.label') }}
          </b-button>
        </div>
      </div>
      <div v-else class="h-100">
        <div v-if="invitationStage == 'loading'" class="d-flex align-items-center h-75">
          <div class="dot-opacity-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div v-else class="d-flex align-items-center h-75 text-center">
          <div v-if="invitationStage == 'success'" class="justify-content-center">
            <h4 class="mb-4">
              {{ $t('users.modal.successTitle', [resultEmails.length]) }}
            </h4>
            <p class="subtitle">{{ $t('users.modal.usersAdded') }}</p>
            <div class="text-center p-4">
              <svg-icon name="check" size="48" class="fill-icon icon-primary"></svg-icon>
            </div>
          </div>
          <div v-else class="justify-content-center">
            <h4 class="mb-4">{{ $t('users.modal.failTitle') }}</h4>
            <p class="subtitle">{{ $t('users.modal.failUsers') }}</p>
            <div class="text-center p-4">
              <svg-icon name="x" size="48" class="fill-icon icon-danger"></svg-icon>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            :disabled="invitationStage == 'loading'"
            size="lg"
            variant="primary"
            @click="onClose"
          >
            {{ $t('button.ok.label') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import addUsersToOrgMulti from '@/api/user/mutations/addUsersToOrgMulti.gql';
import objectsQuery from '@/api/objects/availableObjects.gql';

export default {
  name: 'UsersAddUser',
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    show: false,
    role: 'OEE_USER',
    objectId: '',
    emailString: '',
    arrayOfEmails: [],
    validationFail: [],
    validationFull: [],
    viewOk: false,
    resultEmails: [],
    invitationStage: 'loading',
  }),
  computed: {
    buttonControl() {
      return this.emailString.length > 0;
    },
    state() {
      return this.validationFail.length == 0;
    },
    groupOptions() {
      return [
        {
          value: 'OEE_PM',
          text: this.$t('roles.OEE_PM'),
        },
        {
          value: 'OEE_USER',
          text: this.$t('roles.OEE_USER'),
        },
      ];
    },
  },
  apollo: {
    availableObjects: {
      query() {
        return objectsQuery;
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        var t = (queryData.availableObjects || []).map((object) => {
          return {
            text: object.name,
            value: object.id,
          };
        });
        return t;
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
  watch: {
    availableObjects(objectOptions) {
      this.objectId = objectOptions[0].value;
    },
  },
  methods: {
    splitString(stringToSplit, separator) {
      var arrayOfEmails = stringToSplit.split(separator).map((item) => item.trim());
      this.validationFull = arrayOfEmails.filter((item) => {
        return item.length && this.validateEmail(item);
      });
      this.validationFail = arrayOfEmails.filter(
        (e) => this.validationFull.findIndex((i) => i == e) === -1,
      );
      return this.validationFull;
    },
    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
      return re.test(email);
    },
    onOk() {
      let comma = ',';
      this.resultEmails = this.splitString(this.emailString.trim(), comma);
      if (this.resultEmails && this.state) {
        this.invite();
        this.viewOk = true;
      }
    },
    onClose() {
      this.validationFail = [];
      this.validationFull = [];
      this.arrayOfEmails = [];
      this.emailString = '';
      this.invitationStage = 'loading';
      this.show = false;
      this.viewOk = false;
    },
    onHide() {
      this.onClose();
    },
    invite() {
      this.$apollo
        .mutate({
          mutation: addUsersToOrgMulti,
          variables: {
            emails: this.resultEmails,
            objectId: this.objectId,
            group: this.role,
          },
        })
        .then(() => {
          this.invitationStage = 'success';
          this.$emit('refresh');
        })
        .catch((e) => {
          this.invitationStage = 'error';
          console.log(e.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modalHeight {
  height: 525px;
  min-height: 525px;
}
#email {
  color: black;
}
.scrollbar::-webkit-scrollbar {
  width: 0px;
}
</style>
